module.exports = __webpack_public_path__ + "static/media/sfx_animal_koala.6c8b5260.mp3";